import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MAT_LEGACY_DIALOG_DATA, MatLegacyDialogRef } from '@angular/material/legacy-dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'xcdrs-membership-blocked-dialog',
  standalone: true,
  imports: [CommonModule, TranslateModule, MatLegacyButtonModule],
  templateUrl: './membership-blocked-dialog.component.html',
  styleUrl: './membership-blocked-dialog.component.scss'
})
export class MembershipBlockedDialogComponent {

  isArabic: boolean = false;

  constructor(
    @Inject(MAT_LEGACY_DIALOG_DATA) public data: any,
    private dialogRef: MatLegacyDialogRef<MembershipBlockedDialogComponent>
  ) {
    this.getLanguage();
  }

  getLanguage() {
    let lang = JSON.parse(localStorage.getItem("preferredLanguage"));
    if (lang) this.isArabic = lang.locale == 'ar' || false;
  }

  close() {
    this.dialogRef.close();
  }
}
